import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faTimesCircle,
  faCheckCircle,
  faSync,
  faExclamationCircle,
  faTimes,
  faExternalLinkAlt,
  faPlusCircle,
  faMinusCircle,
  faExchangeAlt,
  faMap,
  faExclamationTriangle,
  faThermometerHalf,
  faSearch,
  faRecycle,
  faChartPie,
  faEnvelope,
  faClipboardList,
  faHatWizard,
  faSignOutAlt,
  faSignInAlt,
  faPlay,
  faTasks,
  faFilter,
  faEdit,
  faPaperPlane,
  faComments,
  faFlagCheckered,
  faDotCircle,
  faReply,
  faUndo,
  faCheck,
  faStop,
  faGhost,
  faMoneyBill,
  faGlobe,
} from '@fortawesome/free-solid-svg-icons'

library.add(faTimes)
library.add(faTimesCircle)
library.add(faCheckCircle)
library.add(faSync)
library.add(faExclamationCircle)
library.add(faExternalLinkAlt)
library.add(faPlusCircle)
library.add(faMinusCircle)
library.add(faExchangeAlt)
library.add(faMap)
library.add(faExclamationTriangle)
library.add(faThermometerHalf)
library.add(faSearch)
library.add(faRecycle)
library.add(faChartPie)
library.add(faEnvelope)
library.add(faClipboardList)
library.add(faHatWizard)
library.add(faSignInAlt)
library.add(faSignOutAlt)
library.add(faPlay)
library.add(faTasks)
library.add(faFilter)
library.add(faEdit)
library.add(faPaperPlane)
library.add(faComments)
library.add(faFlagCheckered)
library.add(faDotCircle)
library.add(faReply)
library.add(faUndo)
library.add(faCheck)
library.add(faStop)
library.add(faGhost)
library.add(faMoneyBill)
library.add(faGlobe)
